<template>
  <div class="grid-drawer-form">
    <drawer
      ref="formDrawer"
      :title="title"
      v-model="visible"
      :width="'30%'"
      :maskClosable="false"
      @on-close="handleClose"
      @update-scroller="updateElScroller"
    >
      <el-scrollbar ref="elScorller" style="height: 100%" wrap-class="form-scroll-wrap" wrap-style="overflow-x:hidden;">
        <component :is="formCmp"
                   v-if="formCmp !== ''"
                   ref="myForm"
                   :type="'drawer'"
                   :formConfig="formConfig"
                   :showHeader="false"
                   :showFooter="false"
                   @submit-start="submitStart"
                   @submit-success="submitSuccess"
                   @submit-error="submitError"
                   @change-router="handleChangeRouter"
        ></component>
      </el-scrollbar>
      <div class="popup-foot group">
        <whaty-button :disabled="submitButtonDisabled" button-class="btn btn-solid-primary" @click="handleSubmit">提交</whaty-button>
        <whaty-button button-class="btn btn-anti-default" @click="handleCancel">取消</whaty-button>
      </div>
    </drawer>
  </div>
</template>
<script>
  import Drawer from '../drawer/drawer'
  import WhatyButton from '../whaty-button'
  // import CommonForm from './common-form'
  export default {
    name: 'drawer-form',
    // components: {CommonForm, Drawer},
    components: {WhatyButton, Drawer},
    props: {
      formConfig: {
        type: Object,
        default() {
          return {}
        }
      },
      formCmpName: {
        type: String
      }
    },
    data() {
      return {
        visible: false,
        submitButtonDisabled: false
      }
    },
    computed: {
      title: function () {
        return this.formConfig.title || ''
      },
      formCmp: function () {
        if (this.formCmpName) {
          let cmpName = this.formCmpName
          return require(`../../custom/components/grid-add-forms/${cmpName}.vue`).default
        }
        return require('./common-form.vue').default
      }
    },
    mounted() {
    },
    methods: {
      show() {
        this.$refs.formDrawer.$el.querySelector('.form-scroll-wrap').addEventListener('scroll', this.$refs.myForm.closeFormDrop)
        this.enableSubmitButton()
        this.visible = true
        this.resetForm()
      },
      hide() {
        this.visible = false
      },
      // 重置form表单
      resetForm() {
        if (this.$refs.myForm && this.$refs.myForm.resetForm) {
          this.$refs.myForm.resetForm()
        }
      },
      // drawer关闭时触发
      handleClose() {
        this.removeScrollListener()
        this.resetForm()
        this.$emit('close')
      },
      submitStart() {
        this.disableSubmitButton()
        this.$emit('submit-start')
      },
      submitSuccess() {
        this.enableSubmitButton()
        this.$emit('submit-success')
      },
      submitError() {
        this.enableSubmitButton()
        this.$emit('submit-error')
      },
      handleChangeRouter(router) {
        this.enableSubmitButton()
        this.$emit('change-router', router)
      },
      handleSubmit() {
        if (this.$refs.myForm && this.$refs.myForm.handleSubmit) {
          this.$refs.myForm.handleSubmit()
        } else {
          console.warn('submit方法未定义')
        }
      },
      handleCancel() {
        this.removeScrollListener()
        this.hide()
      },
      disableSubmitButton() {
        this.submitButtonDisabled = true
      },
      enableSubmitButton() {
        this.submitButtonDisabled = false
      },
      updateElScroller() {
        if (this.$refs.elScorller) {
          this.$refs.elScorller.update()
        }
      },
      removeScrollListener() {
        this.$refs.formDrawer.$el.querySelector('.form-scroll-wrap').removeEventListener('scroll', this.$refs.myForm.closeFormDrop)
      }
    }
  }
</script>
<style lang="scss">

.grid-drawer-form {
  .popup-foot {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 24px;
    text-align: left;
  }

  .popup-foot .btn {
    width: 47%;
    margin: 0 3%;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
  }

  .popup-content {
    padding-top: 16px;
  }

  .form-table-wrap {
    margin-top: 10px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/grid/drawer-form.vue